import { useState } from "react";
import type { MouseEvent } from "react";
type ToggleState = "open" | "close";
export type PanelState = keyof PanelsState;
type PanelsState = Record<string, ToggleState>;

export default function useFlightCardTabs() {
  const [activeTab, setActiveTab] = useState<string | null>(null);

  const handleTabChange = (tab: string) => (e: MouseEvent) => {
    setActiveTab((prev) => (prev === tab ? null : tab));
  };

  return {
    activeTab,
    handleTabChange,
  };
}
